module.exports = __webpack_public_path__ + "static/media/pla_mir.03f99aa4.png";